import {
  FormDataConsumer,
  PasswordInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";

import "../../common/styles/form-style.css";

interface Props {
  toolbar?: React.ReactElement;
}

const supportedProviders = [
  { id: "Compass", name: "Compass" },
  { id: "EFS", name: "EFS" },
];

export const FuelProviderForm = (props: Props) => {
  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...props}>
      <TextInput
        source="name"
        label="resources.admin-fuel-providers.labels.name"
      />
      <SelectInput
        source="provider"
        label="resources.admin-fuel-providers.labels.provider"
        choices={supportedProviders}
        validate={required()}
      />

      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.provider === "Compass" ? (
            <>
              <TextInput
                source="configuration.authToken"
                validate={required()}
                label="resources.admin-fuel-providers.labels.authToken"
                {...rest}
              />
            </>
          ) : formData.provider === "EFS" ? (
            <>
              <TextInput
                source="configuration.userName"
                validate={required()}
                label="resources.admin-fuel-providers.labels.userName"
                {...rest}
              />
              <PasswordInput
                source="configuration.password"
                validate={required()}
                label="resources.admin-fuel-providers.labels.password"
                {...rest}
              />
            </>
          ) : null
        }
      </FormDataConsumer>
    </SimpleForm>
  );
};
